import API from "@aws-amplify/api";
import {
  createCustomCodeExecutionEnvironment,
  deleteCustomCodeExecutionEnvironment,
  updateCustomCodeExecutionEnvironment,
} from "../../graphql/mutations";
import {
  customCodeExecutionEnvironmentsByWorkspace,
  getCustomCodeExecutionEnvironment,
} from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createCustomCodeExecutionEnvironment_ = async (object, userId = null) => {
  const input = { ...object };
  if (userId) {
    input.createdBy = userId;
    input.updatedBy = userId;
  }
  return makeGraphQLRequest({
    query: createCustomCodeExecutionEnvironment,
    variables: { input },
  });
};
const getCustomCodeExecutionEnvironment_ = async (id) => {
  return makeGraphQLRequest({
    query: getCustomCodeExecutionEnvironment,
    variables: { id },
  });
};
const updateCustomCodeExecutionEnvironment_ = async (id, _properties = {}, userId = null) => {
  const original = await getCustomCodeExecutionEnvironment_(id);
  const input = {
    id,
    _version: original?.data?.getCustomCodeExecutionEnvironment?._version,
    ..._properties,
  };
  if (userId) {
    input.updatedBy = userId;
  }
  return makeGraphQLRequest({
    query: updateCustomCodeExecutionEnvironment,
    variables: { input },
  });
};

const deleteCustomCodeExecutionEnvironment_ = async (id) => {
  const original = await getCustomCodeExecutionEnvironment_(id);
  return makeGraphQLRequest({
    query: deleteCustomCodeExecutionEnvironment,
    variables: {
      input: {
        id,
        _version: original?.data?.getCustomCodeExecutionEnvironment?._version,
      },
    },
  });
};

const getCustomCodeExecutionEnvironments_ = async (workspaceID, nextToken) => {
  return makeGraphQLRequest({
    query: customCodeExecutionEnvironmentsByWorkspace,
    variables: {
      workspaceID,
      nextToken,
    },
  });
};

export default {
  createCustomCodeExecutionEnvironment: createCustomCodeExecutionEnvironment_,
  updateCustomCodeExecutionEnvironment: updateCustomCodeExecutionEnvironment_,
  deleteCustomCodeExecutionEnvironment: deleteCustomCodeExecutionEnvironment_,
  getCustomCodeExecutionEnvironment: getCustomCodeExecutionEnvironment_,
  getCustomCodeExecutionEnvironments: getCustomCodeExecutionEnvironments_,
};
